var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.624 5.416c0-.73.593-1.324 1.324-1.324H27.3c.73 0 1.324.593 1.324 1.324v21.352a1.325 1.325 0 0 1-1.324 1.324H5.948a1.326 1.326 0 0 1-1.324-1.324V5.416zm2.667 1.342v18.667h18.666V6.758H7.291zm7.496 4.554 6.505 4.336a.534.534 0 0 1 0 .888l-6.507 4.336a.533.533 0 0 1-.828-.443v-8.674a.533.533 0 0 1 .83-.443z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic-play.a7cced7d84a953e129c4806e73c7d174.svg";
export { ForwardRef as ReactComponent };